export default __webpack_public_path__ + "static/media/bannerr6.5fda3786.webp";